var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.5C11.6562 12.5 12 12.8438 12 13.25C12 13.6875 11.6562 14 11.25 14H0.75C0.3125 14 0 13.6875 0 13.25C0 12.8125 0.3125 12.5 0.75 12.5H11.25ZM9.4375 5.5C9.71875 5.1875 10.1875 5.1875 10.5 5.46875C10.8125 5.75 10.8125 6.21875 10.5312 6.53125L6.53125 10.7812C6.25 11.0938 5.71875 11.0938 5.4375 10.7812L1.4375 6.53125C1.15625 6.21875 1.15625 5.75 1.46875 5.46875C1.625 5.34375 1.8125 5.28125 2 5.28125C2.1875 5.28125 2.375 5.34375 2.53125 5.5L5.25 8.375V0.78125C5.25 0.34375 5.5625 0 6 0C6.40625 0 6.75 0.34375 6.75 0.78125V8.375L9.4375 5.5Z",
    fill: "#DD2A57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.dfe5c62f66723745b2ba09c842da3b74.svg";
export { ForwardRef as ReactComponent };